<template>
  <div class="alterphone">
    <van-nav-bar title="修改手机号" left-text="" fixed left-arrow @click-left="goBack" @click-right="onClickRight">

    </van-nav-bar>
    <div class="van-content">
      <van-cell-group>
        <van-field type="number" value="请输入已绑定手机号" label="原手机号" v-model="oldmobile"></van-field>
        <van-field type="number" value="请输入手机号" label="手机号" v-model="mobile"></van-field>
        <van-field value="请输入验证码" label="验证码" v-model="code">
          <van-button slot="button" size="small" type="primary" class="theme-bd theme-bg codebtn" @click="getCode" :loading="codeLoading">发送验证码</van-button>
        </van-field>
      </van-cell-group>
      <van-button size="large" class="addSiteBtn theme-bd theme-bg" @click="sendData">确定</van-button>
    </div>

  </div>
</template>

<script>
  export default {
    name: "phone",
    data () {
      return {
        oldmobile:'',
        mobile:'',
        code:'',
        codeLoading:false,
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        console.log('按钮');
      },
      sendData: function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Info/mobile', {token:isUser,oldmobile:this.oldmobile,mobile:this.mobile,code:this.code}, res => {
          if(res.data.errCode == '0000'){
            this.$router.push({ name: 'User' })
          }else{
            this.$toast(res.data.desc);
          }
        })
      },
      getCode: function () {
        var _this = this
        var reg=/^[1][3456789][0-9]{9}$/;
        if (reg.test(this.mobile)){
          this.codeLoading = true
          this.$api.post('WebApi/Login/Register/sendMmsCode', {mobile:this.mobile}, res => {
            if(res.data.errCode == '0000'){
              this.$toast("发送成功请注意查收")
              var time = 60
              var dd = setInterval(function () {
                time--
                $(".alterphone .codebtn").html(time+' s')
                if(time <= 0){
                  clearInterval(dd)
                  _this.codeLoading = false
                  $(".alterphone .codebtn").html('<span class=\\"van-button__text\\">重新发送</span>')
                }
              },1000)
            }else {
              this.$toast(res.data.desc)
              _this.codeLoading = false
            }
          })
        }else{
          this.$toast("请输入正确的手机号码");
          return false;
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .alterphone{
    .van-cell-group{
      background-color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/phone.vue